'use client';
const plans = [
  {
    icon: 'fas fa-stethoscope',
    title: 'Consultation Générale',
    price: '15 000',
    currency: 'FCFA',
    featured: false,
    features: ['Médecin Généraliste', 'Consultation Médicale', 'Ordonnance', 'Suivi Patient'],
  },
  {
    icon: 'fas fa-hospital',
    title: 'Bilan de Santé Complet',
    price: '75 000',
    currency: 'FCFA',
    featured: true,
    features: ['Consultation Spécialisée', 'Analyses Biomédicales', 'Radiologie', 'Rapport Médical'],
  },
  {
    icon: 'fas fa-user-md',
    title: 'Consultation Spécialisée',
    price: '25 000',
    currency: 'FCFA',
    featured: false,
    features: ['Pédiatrie / Gynécologie', 'Ophtalmologie / ORL', 'Diabétologie', 'Fibroscopie'],
  },
];

export default function PricingSection() {
  return (
    <section id="pricing-1" className="wide-60">
      <div className="max-w-7xl mx-auto px-4">
        {/* TITLE */}
        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
            Des Soins de Qualité Accessibles à Tous
          </h3>
          <p className="text-gray-500 max-w-xl mx-auto">
            COSA s'engage à offrir des soins de santé de haute qualité à des tarifs accessibles, conformément à notre mission d'accessibilité pour tous.
          </p>
        </div>

        {/* PRICING TABLES */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {plans?.map((plan, i) => (
            <div
              key={i}
              className="rounded-xl p-10 text-center flex flex-col items-center transition-all duration-300 hover:-translate-y-2"
              style={{
                backgroundColor: plan?.featured ? '#0e5932' : '#fff',
                boxShadow: plan?.featured
                  ? '0 15px 50px rgba(14,89,50,0.35)'
                  : '0 3px 20px rgba(0,0,0,0.08)',
              }}
            >
              {/* Icon */}
              <div
                className="text-5xl mb-4"
                style={{ color: plan?.featured ? 'rgba(255,255,255,0.8)' : '#0e5932' }}
              >
                <i className={plan?.icon}></i>
              </div>

              {/* Title */}
              <h5
                className="text-xl font-bold mb-6"
                style={{ color: plan?.featured ? '#fff' : '#1d3c5e', fontFamily: 'Lato, sans-serif' }}
              >
                {plan?.title}
              </h5>

              {/* Price */}
              <div className="mb-6">
                <div className="flex items-start justify-center gap-1">
                  <span
                    className="text-4xl font-black leading-none"
                    style={{ color: plan?.featured ? '#fff' : '#1d3c5e', fontFamily: 'Lato, sans-serif' }}
                  >
                    {plan?.price}
                  </span>
                </div>
                <p className="text-sm mt-1" style={{ color: plan?.featured ? 'rgba(255,255,255,0.7)' : '#888' }}>
                  {plan?.currency}
                </p>
              </div>

              {/* Features */}
              <ul className="w-full mb-8 list-none p-0">
                {plan?.features?.map((feat, j) => (
                  <li
                    key={j}
                    className="py-3 text-sm"
                    style={{
                      borderBottom: j < plan?.features?.length - 1
                        ? `1px solid ${plan?.featured ? 'rgba(255,255,255,0.2)' : '#f0f0f0'}`
                        : 'none',
                      color: plan?.featured ? 'rgba(255,255,255,0.85)' : '#555',
                    }}
                  >
                    {feat}
                  </li>
                ))}
              </ul>

              {/* Button */}
              <a
                href="#"
                className="inline-block px-8 py-3 rounded font-bold text-sm uppercase tracking-wide transition-all"
                style={{
                  border: `2px solid ${plan?.featured ? '#fff' : '#333'}`,
                  color: plan?.featured ? '#fff' : '#333',
                  backgroundColor: 'transparent',
                  letterSpacing: '0.5px',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = '#fbaf45';
                  e.currentTarget.style.borderColor = '#fbaf45';
                  e.currentTarget.style.color = '#fff';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = plan?.featured ? '#fff' : '#333';
                  e.currentTarget.style.color = plan?.featured ? '#fff' : '#333';
                }}
              >
                Prendre RDV
              </a>
            </div>
          ))}
        </div>

        {/* NOTE */}
        <div className="text-center">
          <p className="text-sm text-gray-500 max-w-2xl mx-auto">
            <span className="font-bold" style={{ color: '#0e5932' }}>Note :</span>{' '}
            Les tarifs indiqués sont donnés à titre indicatif. COSA collabore avec les assurances santé et les entreprises partenaires pour faciliter la prise en charge de vos soins médicaux.
          </p>
        </div>
      </div>
    </section>
  );
}
